/************************************************************************************************
 * Copyright TRUSST AI PTY LTD. All Rights Reserved.                                            *
 *                                                                                              *
 * Licensed under the TRUSST SOFTWARE LICENSE (the "License"). You may not use this file except *
 * in compliance with the "LICENSE" file accompanying this file. This file is distributed       *
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, express or implied.       *
 *                                                                                              *
 * See the "License" file for the specific language governing permissions and limitations       *
 * under the License and limitations under the License.                                         *
 ***********************************************************************************************/

import {PromptRevision, useListPromptRevisions} from '@agent-assist/api-typescript-react-query-hooks';

import {OptionDefinition} from '@cloudscape-design/components/internal/components/option/interfaces';

import React, {useState} from 'react';

import {useNavigate} from 'react-router-dom';
import InfiniteSelect from '../InfiniteSelect/InfiniteSelect';

interface SelectCriteriaProps {
  handleCriteriaIdChanged?: (criteriaId: string, options: OptionDefinition[]) => void;
  initialValue?: string;
}

const defaultCriteria = {value: '_DEFAULT_PROMPT', label: 'Default Criteria'};
export const contactToOption = (criteria: PromptRevision): OptionDefinition => {
  return {
    value: criteria.promptRevisionId,
    label: criteria.name,
  };
};

export const SelectCriteria = ({initialValue}: SelectCriteriaProps) => {
  const navigate = useNavigate();
  const listCriteraNames = useListPromptRevisions({
    pageSize: 300,
  });
  const options = React.useMemo(() => {
    const criteriaList = listCriteraNames.data?.pages.flatMap((p: any) => p.revisions) ?? [];
    return [defaultCriteria, ...criteriaList.map(contactToOption)];
  }, [listCriteraNames]);

  const [selectedCriteria, setSelectedCriteria] = useState<OptionDefinition | null>(null);

  return (
    <InfiniteSelect
      placeholder={'Select a Criteria'}
      query={listCriteraNames}
      options={options}
      itemsKey={'criteriaList'}
      toOption={contactToOption}
      onChange={(criteriaId: string) => {
        navigate(`/analytics/${criteriaId}`);
        setSelectedCriteria(options.find((option) => option.value === criteriaId) ?? null);
      }}
      emptyLabel={'No Criteria found to list'}
      initialValue={initialValue ?? selectedCriteria?.value}
    />
  );
};
